class GalleryProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;

    this.mainElement = this.closest('.product-main-element');
    this.slides = this.mainElement.isBundle ? this.dataset.slides : 1;
  }

  connectedCallback() {
    this.initSwiper();
    this.setupPhotoSwipe();
    this.setupVideoPlayer();
    window.addEventListener('resize', this.onResize.bind(this));
  }

  disconnectedCallback() {
    this.destroySwiper();
    window.removeEventListener('resize', this.onResize.bind(this));
  }

  isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  initSwiper() {
    if (this.isMobile() && !this.swiper) {
      const swiperElement = this.querySelector('.gallery-product-swiper');
      if (swiperElement) {
        this.swiper = new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 8,
          loop: false,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            dynamicBullets: true,
          },
        });
      }
    }
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  onResize() {
    if (this.isMobile() && !this.swiper) {
      this.initSwiper();
    } else if (!this.isMobile() && this.swiper) {
      this.destroySwiper();
    }
  }

  setupPhotoSwipe() {
    if(!this.closest('.tingle-modal')) {
      this.querySelectorAll('[data-file]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          var visibleItems = [];
          this.querySelectorAll('[data-media-id]').forEach((obj)=>{
            if($s.isVisible(obj)) {
              let element  = obj.querySelector('[data-file], video, iframe');
              if(element) {
                visibleItems.push(element);
              }
            }
          });
          $s.photoSwipe(visibleItems, media);
        });
      });
      //3D Models
      this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
        model.addEventListener('click', (e)=>{
          $s.photoSwipe([model.querySelector('template').content.firstElementChild]);
        });
      });
    }
  }

  setupVideoPlayer() {
    const videoPlayers = this.querySelectorAll('.js-video-player');

    if(!videoPlayers.length) return;
    videoPlayers.forEach((videoPlayer)=>{
      const video = videoPlayer.querySelector('video');

      videoPlayer.addEventListener('click', (e)=>{
        e.preventDefault();
        if(video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', () => {
        video.controls = true;
        videoPlayer.classList.add('is-playing');
      });

      video.addEventListener('pause', () => {
        video.controls = false;
        videoPlayer.classList.remove('is-playing');
      });
    });
  }
}

customElements.define('gallery-product-slider', GalleryProductSlider);
